import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { LoadingScreen } from './LoadingScreen'

export const AuthGate = ({ children }) => {
  const { isAuthed, isLoading, needsOnboarding, user } = useAuth()
  const location = useLocation()

  if (isLoading) return <LoadingScreen />

  if (!isAuthed) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Email must be verified before accessing the app.
  // Exempt /verify-email itself and admin paths (super-admins are created via backend).
  const emailVerified = !!user?.email_confirmed_at
  if (!emailVerified && location.pathname !== '/verify-email' && !location.pathname.startsWith('/admin')) {
    return <Navigate to="/verify-email" replace />
  }

  // First-time users (no household yet) must complete onboarding.
  // Admin paths bypass this — super-admins may not have a household yet.
  if (needsOnboarding && location.pathname !== '/onboarding' && !location.pathname.startsWith('/admin')) {
    return <Navigate to="/onboarding" replace />
  }

  return children
}
